const NAV_THEME_STORAGE_KEY = 'app_nav_theme';

export const saveNavTheme = (theme: 'light' | 'realDark') => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(NAV_THEME_STORAGE_KEY, theme);
};

/** Preserve explicit preferences; new sessions start in dark mode. */
export const getInitialNavTheme = (): 'light' | 'realDark' => {
  try {
    return window.localStorage.getItem(NAV_THEME_STORAGE_KEY) === 'light'
      ? 'light'
      : 'realDark';
  } catch {
    return 'realDark';
  }
};

/** This core version treats any initialState as a complete session snapshot.
 * Seed its existing preference key instead, so auth/tenant bootstrap still runs.
 */
export const initializeNavThemePreference = () => {
  try {
    const stored = window.localStorage.getItem(NAV_THEME_STORAGE_KEY);
    if (stored !== 'light' && stored !== 'realDark') {
      window.localStorage.setItem(NAV_THEME_STORAGE_KEY, 'realDark');
    }
  } catch {
    // Keep the platform bootstrap available when browser storage is disabled.
  }
};
